import { Product } from '../../types';

export const series0250Products: Product[] = [
  {
    id: "bt-0250-swt025001",
    name: "0250 Series Terminal - No 18 6.4 Female Slot (SWT025001)",
    slug: "0250-series-terminal-no-18-6-4-female-slot-swt025001",
    category: "Brass Terminal",
    subcategory: "0250 Series",
    description: "No 18 6.4mm female slot terminal. Standard automotive blade terminal for high current applications.",
    partNumber: "SWT025001",
    featured: true,
    specifications: {
      "Tab Size Ø": "6.40 mm",
      "Cable Size SQ. MM": "2.00-3.20",
      "Description": "No 18 6.4 Female Slot",
      "Material": "CuZn-63/37",
      "Standard Packing": "Spool-4000 Cut-1000",
    },
    images: ["/products/brass-terminals/0250-series/SWT025001.jpg"],
    tags: ["terminal", "0250", "brass", "female", "slot", "6.4mm"],
    applications: ["Automotive", "High Current"],
  },
  {
    id: "bt-0250-swt025002",
    name: "0250 Series Terminal - No 18 6.4 Female Lock (SWT025002)",
    slug: "0250-series-terminal-no-18-6-4-female-lock-swt025002",
    category: "Brass Terminal",
    subcategory: "0250 Series",
    description: "No 18 6.4mm female lock terminal with locking tab. Enhanced retention for secure connections.",
    partNumber: "SWT025002",
    specifications: {
      "Tab Size Ø": "6.00 mm",
      "Cable Size SQ. MM": "2.00-3.20",
      "Description": "No 18 6.4 Female Lock",
      "Material": "CuZn-63/37",
      "Standard Packing": "Spool-4000 Cut-1000",
    },
    images: ["/products/brass-terminals/0250-series/SWT025002.jpg"],
    tags: ["terminal", "0250", "brass", "female", "lock", "6.4mm"],
    applications: ["Automotive", "High Current"],
  },
  {
    id: "bt-0250-swt025003",
    name: "0250 Series Terminal - No 18 6.4 Female Plain (SWT025003)",
    slug: "0250-series-terminal-no-18-6-4-female-plain-swt025003",
    category: "Brass Terminal",
    subcategory: "0250 Series",
    description: "No 18 6.4mm female plain terminal. Standard blade terminal without slot or locking mechanism.",
    partNumber: "SWT025003",
    specifications: {
      "Tab Size Ø": "6.00 mm",
      "Cable Size SQ. MM": "2.00-3.20",
      "Description": "No 18 6.4 Female Plain",
      "Material": "CuZn-63/37",
      "Standard Packing": "Spool-5000 Cut-1000",
    },
    images: ["/products/brass-terminals/0250-series/SWT025003.jpg"],
    tags: ["terminal", "0250", "brass", "female", "plain", "6.4mm"],
    applications: ["Automotive", "High Current"],
  },
  {
    id: "bt-0250-swt025004",
    name: "0250 Series Terminal - No 18 6.4 Female Slot Long Leg (SWT025004)",
    slug: "0250-series-terminal-no-18-6-4-female-slot-long-leg-swt025004",
    category: "Brass Terminal",
    subcategory: "0250 Series",
    description: "No 18 6.4mm female slot terminal with long leg crimp barrel. For larger cable applications.",
    partNumber: "SWT025004",
    specifications: {
      "Tab Size Ø": "6.40 mm",
      "Cable Size SQ. MM": "3.00-4.00",
      "Description": "No 18 6.4 Female Slot Long Leg",
      "Material": "CuZn-63/37",
      "Standard Packing": "Spool-N/A Cut-1000",
    },
    images: ["/products/brass-terminals/0250-series/SWT025004.jpg"],
    tags: ["terminal", "0250", "brass", "female", "slot", "long-leg", "6.4mm"],
    applications: ["Automotive", "High Current", "Large Cable"],
  },
  {
    id: "bt-0250-swt025005",
    name: "0250 Series Terminal - No 18 6.4 Female 3 Dimple (SWT025005)",
    slug: "0250-series-terminal-no-18-6-4-female-3-dimple-swt025005",
    category: "Brass Terminal",
    subcategory: "0250 Series",
    description: "No 18 6.4mm female terminal with three dimples on crimp barrel. Enhanced crimp retention.",
    partNumber: "SWT025005",
    specifications: {
      "Tab Size Ø": "6.40 mm",
      "Cable Size SQ. MM": "2.80-3.80",
      "Description": "No 18 6.4 Female 3 Dimple",
      "Material": "CuZn-63/37",
      "Standard Packing": "Spool-N/A Cut-1000",
    },
    images: ["/products/brass-terminals/0250-series/SWT025005.jpg"],
    tags: ["terminal", "0250", "brass", "female", "dimple", "6.4mm"],
    applications: ["Automotive", "High Current"],
  },
  {
    id: "bt-0250-swt025006",
    name: "0250 Series Terminal - No 18 6.4 Female Dimple Plain (SWT025006)",
    slug: "0250-series-terminal-no-18-6-4-female-dimple-plain-swt025006",
    category: "Brass Terminal",
    subcategory: "0250 Series",
    description: "No 18 6.4mm female terminal with single dimple on crimp barrel. Standard plain design with dimple retention.",
    partNumber: "SWT025006",
    specifications: {
      "Tab Size Ø": "6.00 mm",
      "Cable Size SQ. MM": "2.00-3.20",
      "Description": "No 18 6.4 Female Dimple Plain",
      "Material": "CuZn-63/37",
      "Standard Packing": "Spool-4000 Cut-1000",
    },
    images: ["/products/brass-terminals/0250-series/SWT025006.jpg"],
    tags: ["terminal", "0250", "brass", "female", "dimple", "plain", "6.4mm"],
    applications: ["Automotive", "High Current"],
  },
  {
    id: "bt-0250-swt025011",
    name: "0250 Series Terminal - 6.4 Male Window (SWT025011)",
    slug: "0250-series-terminal-6-4-male-window-swt025011",
    category: "Brass Terminal",
    subcategory: "0250 Series",
    description: "6.4mm male window terminal with flat rectangular blade. Male blade terminal for high current applications.",
    partNumber: "SWT025011",
    specifications: {
      "Tab Size Ø": "7.30 mm",
      "Cable Size SQ. MM": "1.90-2.90",
      "Description": "6.4 Male Window",
      "Material": "CuZn-63/37",
      "Standard Packing": "Spool-4000 Cut-1000",
    },
    images: ["/products/brass-terminals/0250-series/SWT025011.jpg"],
    tags: ["terminal", "0250", "brass", "male", "window", "6.4mm"],
    applications: ["Automotive", "High Current"],
  },
  {
    id: "bt-0250-swt025012",
    name: "0250 Series Terminal - 6.4 Male Lock (SWT025012)",
    slug: "0250-series-terminal-6-4-male-lock-swt025012",
    category: "Brass Terminal",
    subcategory: "0250 Series",
    description: "6.4mm male lock terminal with locking feature. Male blade terminal for secure connections.",
    partNumber: "SWT025012",
    specifications: {
      "Tab Size Ø": "7.40 mm",
      "Cable Size SQ. MM": "1.90-2.90",
      "Description": "6.4 Male Lock",
      "Material": "CuZn-63/37",
      "Standard Packing": "Spool-4000 Cut-1000",
    },
    images: ["/products/brass-terminals/0250-series/SWT025012.jpg"],
    tags: ["terminal", "0250", "brass", "male", "lock", "6.4mm"],
    applications: ["Automotive", "High Current"],
  },
  {
    id: "bt-0250-swt025013",
    name: "0250 Series Terminal - 6.4 Male Lock Without Hole (SWT025013)",
    slug: "0250-series-terminal-6-4-male-lock-without-hole-swt025013",
    category: "Brass Terminal",
    subcategory: "0250 Series",
    description: "6.4mm male lock terminal without hole. Male blade terminal with locking feature, solid design.",
    partNumber: "SWT025013",
    specifications: {
      "Tab Size Ø": "7.40 mm",
      "Cable Size SQ. MM": "1.90-2.90",
      "Description": "6.4 Male Lock Without Hole",
      "Material": "CuZn-63/37",
      "Standard Packing": "Spool-4000 Cut-1000",
    },
    images: ["/products/brass-terminals/0250-series/SWT025013.jpg"],
    tags: ["terminal", "0250", "brass", "male", "lock", "no-hole", "6.4mm"],
    applications: ["Automotive", "High Current"],
  },
  {
    id: "bt-0250-swt025014",
    name: "0250 Series Terminal - 6.4 Female Flag Lock (SWT025014)",
    slug: "0250-series-terminal-6-4-female-flag-lock-swt025014",
    category: "Brass Terminal",
    subcategory: "0250 Series",
    description: "6.4mm female flag terminal with lock and right-angle bend. Flag terminal for space-constrained applications.",
    partNumber: "SWT025014",
    specifications: {
      "Tab Size Ø": "7.40 mm",
      "Cable Size SQ. MM": "1.90-2.80",
      "Description": "6.4 Female Flag Lock",
      "Material": "CuZn-63/37",
      "Standard Packing": "Spool-4000 Cut-1000",
    },
    images: ["/products/brass-terminals/0250-series/SWT025014.jpg"],
    tags: ["terminal", "0250", "brass", "female", "flag", "lock", "6.4mm"],
    applications: ["Automotive", "High Current", "Space Constrained"],
  },
  {
    id: "bt-0250-swt025015",
    name: "0250 Series Terminal - 6.4 Male (SWT025015)",
    slug: "0250-series-terminal-6-4-male-swt025015",
    category: "Brass Terminal",
    subcategory: "0250 Series",
    description: "6.4mm male terminal with straight spade connector. Standard male blade terminal.",
    partNumber: "SWT025015",
    specifications: {
      "Tab Size Ø": "7.40 mm",
      "Cable Size SQ. MM": "2.00-3.00",
      "Description": "6.4 Male",
      "Material": "CuZn-63/37",
      "Standard Packing": "Spool-4000 Cut-1000",
    },
    images: ["/products/brass-terminals/0250-series/SWT025015.jpg"],
    tags: ["terminal", "0250", "brass", "male", "6.4mm"],
    applications: ["Automotive", "High Current"],
  },
  {
    id: "bt-0250-swt025016",
    name: "0250 Series Terminal - 6.4 Female Flag Slot (SWT025016)",
    slug: "0250-series-terminal-6-4-female-flag-slot-swt025016",
    category: "Brass Terminal",
    subcategory: "0250 Series",
    description: "6.4mm female flag terminal with slot and right-angle bend. Flag terminal for space-constrained applications.",
    partNumber: "SWT025016",
    specifications: {
      "Tab Size Ø": "7.40 mm",
      "Cable Size SQ. MM": "1.90-2.80",
      "Description": "6.4 Female Flag Slot",
      "Material": "CuZn-63/37",
      "Standard Packing": "Spool-3000 Cut-1000",
    },
    images: ["/products/brass-terminals/0250-series/SWT025016.jpg"],
    tags: ["terminal", "0250", "brass", "female", "flag", "slot", "6.4mm"],
    applications: ["Automotive", "High Current", "Space Constrained"],
  },
  {
    id: "bt-0250-swt025017",
    name: "0250 Series Terminal - 6.4 Female Non Insulated (SWT025017)",
    slug: "0250-series-terminal-6-4-female-non-insulated-swt025017",
    category: "Brass Terminal",
    subcategory: "0250 Series",
    description: "6.4mm female non-insulated terminal with right-angle bend. Non-insulated design for direct connections.",
    partNumber: "SWT025017",
    specifications: {
      "Tab Size Ø": "7.40 mm",
      "Cable Size SQ. MM": "1.90-2.80",
      "Description": "6.4 Female Non Insulated",
      "Material": "CuZn-63/37",
      "Standard Packing": "Spool-4000 Cut-1000",
    },
    images: ["/products/brass-terminals/0250-series/SWT025017.jpg"],
    tags: ["terminal", "0250", "brass", "female", "non-insulated", "6.4mm"],
    applications: ["Automotive", "High Current"],
  },
  {
    id: "bt-0250-swt025018",
    name: "0250 Series Terminal - 6.4 Female P-Lock End Feed (SWT025018)",
    slug: "0250-series-terminal-6-4-female-p-lock-end-feed-swt025018",
    category: "Brass Terminal",
    subcategory: "0250 Series",
    description: "6.4mm female P-Lock end feed terminal. Positive lock terminal with end feed design.",
    partNumber: "SWT025018",
    specifications: {
      "Tab Size Ø": "7.40 mm",
      "Cable Size SQ. MM": "2.00-3.00",
      "Description": "6.4 Female P-Lock End Feed",
      "Material": "CuZn-63/37",
      "Standard Packing": "Spool-4000 Cut-1000",
    },
    images: ["/products/brass-terminals/0250-series/SWT025018.jpg"],
    tags: ["terminal", "0250", "brass", "female", "p-lock", "end-feed", "6.4mm"],
    applications: ["Automotive", "High Current"],
  },
  {
    id: "bt-0250-swt025019",
    name: "0250 Series Terminal - 6.4 Female In Lock (SWT025019)",
    slug: "0250-series-terminal-6-4-female-in-lock-swt025019",
    category: "Brass Terminal",
    subcategory: "0250 Series",
    description: "6.4mm female in lock terminal with internal locking mechanism. Enhanced retention for secure connections.",
    partNumber: "SWT025019",
    specifications: {
      "Tab Size Ø": "7.40 mm",
      "Cable Size SQ. MM": "1.90-2.90",
      "Description": "6.4 Female In Lock",
      "Material": "CuZn-63/37",
      "Standard Packing": "Spool-4000 Cut-1000",
    },
    images: ["/products/brass-terminals/0250-series/SWT025019.jpg"],
    tags: ["terminal", "0250", "brass", "female", "in-lock", "6.4mm"],
    applications: ["Automotive", "High Current"],
  },
  {
    id: "bt-0250-swt025020",
    name: "0250 Series Terminal - 6.4 Female Side Feed (SWT025020)",
    slug: "0250-series-terminal-6-4-female-side-feed-swt025020",
    category: "Brass Terminal",
    subcategory: "0250 Series",
    description: "6.4mm female side feed terminal. Side feed design for alternative cable routing.",
    partNumber: "SWT025020",
    specifications: {
      "Tab Size Ø": "6.00 mm",
      "Cable Size SQ. MM": "1.90-2.90",
      "Description": "6.4 Female Side Feed",
      "Material": "CuZn-63/37",
      "Standard Packing": "Spool-4000 Cut-1000",
    },
    images: ["/products/brass-terminals/0250-series/SWT025020.jpg"],
    tags: ["terminal", "0250", "brass", "female", "side-feed", "6.4mm"],
    applications: ["Automotive", "High Current"],
  },
];
